import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterByField'
})
export class FilterByFieldPipe implements PipeTransform {

  transform(items: any[] | undefined, field: string, value: any, all: boolean = false): any[] {
    if (!items) {
      return [];
    }
    if (!field || value === undefined) {
      return items;
    }

    const filteredItems = items.filter(item => item[field] === value);
    return all ? filteredItems : filteredItems.slice(0, 1);
  }
}
